import BASE_RULE from '../baseRule';
import {SearchTypeFileFormatFamily} from './constants';
import {FileFormatFamilyRule} from './types';

export const fileFormatFamilyRuleDefaults: FileFormatFamilyRule = {
	...BASE_RULE,
	elementType: SearchTypeFileFormatFamily,
	elementSubType1: 4,
	elementValue1: '',
};
